export type SubscriptionTier = 'gold' | 'platinum' | 'diamond';

export interface UserProfile {
  id: string;
  full_name?: string;
  organization?: string;
  country_id?: string;
  subscription_tier: SubscriptionTier;
  stripe_customer_id?: string;
  created_at: string;
  updated_at: string;
}

export interface Subscription {
  id: string;
  user_id: string;
  stripe_subscription_id?: string;
  tier: SubscriptionTier;
  status: 'active' | 'canceled' | 'past_due';
  current_period_start?: string;
  current_period_end?: string;
  monthly_lga_limit: number;
  api_rate_limit: number;
  team_member_limit: number;
  created_at: string;
  updated_at: string;
}

export interface UsageTracking {
  id: string;
  user_id: string;
  resource_type: 'lga_report' | 'api_call';
  usage_date: string;
  count: number;
}

export interface AccessLog {
  id: string;
  user_id: string;
  resource_type: 'incident' | 'report' | 'map';
  resource_id: string;
  accessed_at: string;
}

export interface SubscriptionFeatures {
  tier: SubscriptionTier;
  price: number;
  features: string[];
  limits: {
    lga_reports: number | 'unlimited';
    api_calls: number | 'unlimited';
    team_members: number | 'unlimited';
  };
}

export const SUBSCRIPTION_PLANS: Record<SubscriptionTier, SubscriptionFeatures> = {
  gold: {
    tier: 'gold',
    price: 50,
    features: [
      'Access to LGA (Local Government) level reports',
      'View security reports and incident summaries',
      'Email alerts for critical incidents',
      'Basic map visualization',
      'View-only access (no downloads)'
    ],
    limits: {
      lga_reports: 'unlimited',
      api_calls: 0,
      team_members: 1
    }
  },
  platinum: {
    tier: 'platinum',
    price: 75,
    features: [
      'All Gold features',
      'Access to State and Country level reports',
      'View all report levels (LGA, State, Country)',
      'Real-time incident notifications',
      'Advanced analytics and trends',
      'Team collaboration (up to 5 users)',
      'Priority customer support',
      'API access (limited)'
    ],
    limits: {
      lga_reports: 'unlimited',
      api_calls: 1000,
      team_members: 5
    }
  },
  diamond: {
    tier: 'diamond',
    price: 150,
    features: [
      'All Platinum features',
      'Download reports and files',
      'Full download access to all report levels',
      'White-label redistribution rights',
      'Full API access with higher rate limits',
      'Custom report generation',
      'Dedicated account manager',
      'SLA guarantees',
      'Custom integrations',
      'Bulk data exports'
    ],
    limits: {
      lga_reports: 'unlimited',
      api_calls: 'unlimited',
      team_members: 'unlimited'
    }
  }
};
